export const formatPositiveNegative = (val) => {
  if (val === "POSITIVE") return "Positive";
  if (val === "NEGATIVE") return "Negative";
  if (!val) return "Negative";
  return val;
};
